import { render, staticRenderFns } from "./Piao.vue?vue&type=template&id=51dcd42c&"
import script from "./Piao.vue?vue&type=script&lang=js&"
export * from "./Piao.vue?vue&type=script&lang=js&"
import style0 from "./Piao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports